import { LogsFront } from './LogsFront'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { StaticsCarrier } from '../bar/StaticsCarrier'

export const LogsBack = (): JSX.Element | null => {
  const {
    polesNumberBackside,
    staticLogBackside,
    userHeight,
    offsetRoofLog,
    isQubus,
    attachedSize,
    hasBacksideStaticlog,
  } = useMeasures()

  const poles = polesNumberBackside < 2 ? 2 : polesNumberBackside
  const logHeight =
    userHeight +
    (isQubus
      ? 0
      : hasBacksideStaticlog
      ? 0
      : +offsetRoofLog.c - attachedSize.y) -
    (hasBacksideStaticlog ? staticLogBackside.height : 0)
  return (
    <group position={[0, 0, 0]}>
      <LogsFront isBackLog={true} polesNumber={poles} height={logHeight} />
      <StaticsCarrier
        isBackside={hasBacksideStaticlog}
        height={staticLogBackside.height}
        depth={staticLogBackside.depth}
      />
    </group>
  )
}
